define.alias("shared/components/shared/pre-boarding/index", "settings/components/shared/pre-boarding/index");